import styled from 'styled-components';

export default styled.td`
  text-align: right;
  padding: 0.25rem 1rem 0.25rem 1rem;
`;
